<script lang="ts">
  import Button from '$lib/components/control/Button.svelte';
  import Link from '../../../assets/svgs/link.svelte';
  import { BUTTON_SIZE, BUTTON_VARIANT } from '$lib/constants/constants';
  import Tick from '../../../assets/svgs/tick.svelte';
  import { fade } from 'svelte/transition';

  let popupVisible = false;

  function showPopup() {
    navigator.clipboard.writeText(window.location.href);
    popupVisible = true;

    // Automatically hide the popup after 2 seconds
    setTimeout(() => {
      popupVisible = false;
    }, 2000);
  }
</script>

<div class="relative w-max">
  <Button
    text="Share"
    variant={BUTTON_VARIANT.CUSTOM}
    buttonSize={BUTTON_SIZE.MEDIUM}
    customClass="text-gray-400 border-gray-400 plausible-event-name=share_button"
    onClick={showPopup}
  >
    <div slot="left"><Link /></div>
  </Button>

  {#if popupVisible}
    <div
      in:fade={{ duration: 200 }}
      out:fade={{ duration: 350 }}
      class="absolute flex flex-row bg-primary-600 gap-1 rounded-md justify-center items-center pl-3 pr-1 py-0.5 w-full mt-4"
    >
      <p class="text-white text-sm font-semibold">Link copied</p>
      <Tick
        color="#ffffff"
        strokeWidth={2}
        width={16}
        height={16}
        d="M13.3307 4L5.9974 11.3333L2.66406 8"
      />
    </div>
  {/if}
</div>
